import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};

  cursor: pointer;
  &:hover {
    background: ${({ theme }) => theme.colors.black1};
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex-direction: row;
  }
`;

export const InformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const DescriptionWrapper = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;

  font-family: 'Open Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  font-family: ${({ theme }) => theme.fontFamily.primary};
`;
export const Title = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black10};
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
export const TitleWrapper = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  min-width: 0;

  .ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ContentWrapper = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const VideoWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;

  media-player {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 400px;
    max-width: 400px;
  }
`;
